import {SVGProps} from "react"

function Projects(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22 19C22 19.5304 21.7893 20.0391 21.4142 20.4142C21.0391 20.7893 20.5304 21 20 21H4C3.46957 21 2.96086 20.7893 2.58579 20.4142C2.21071 20.0391 2 19.5304 2 19V5C2 4.46957 2.21071 3.96086 2.58579 3.58579C2.96086 3.21071 3.46957 3 4 3H9L11 6H20C20.5304 6 21.0391 6.21071 21.4142 6.58579C21.7893 6.96086 22 7.46957 22 8V19Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Assets(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 2L2 7L12 12L22 7L12 2Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M2 17L12 22L22 17"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M2 12L12 17L22 12"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>

}

function Requirement(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M14 2V8H20"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M16 13H8"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M16 17H8"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M10 9H9H8"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function FilesOutlined(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9L13 2Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M13 2V9H20"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function FilesFilled(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 2H13L20 9V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V4C4 3.46957 4.21071 2.96086 4.58579 2.58579C4.96086 2.21071 5.46957 2 6 2ZM13 5.875V4L18 9H13V5.875Z"
      fill={props.fill ?? "#1D1D1E"}/>
  </svg>
}

function Image(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M8.5 10C9.32843 10 10 9.32843 10 8.5C10 7.67157 9.32843 7 8.5 7C7.67157 7 7 7.67157 7 8.5C7 9.32843 7.67157 10 8.5 10Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M21 15L16 10L5 21"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Tasks(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 4H18C18.5304 4 19.0391 4.21071 19.4142 4.58579C19.7893 4.96086 20 5.46957 20 6V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4H8"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M15 2H9C8.44772 2 8 2.44772 8 3V5C8 5.55228 8.44772 6 9 6H15C15.5523 6 16 5.55228 16 5V3C16 2.44772 15.5523 2 15 2Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M16 14H8"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M16 18H8"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M16 10H12L8 10"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Form(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M14 2V8H20"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M12 18V12"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M9 15H15"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Templates(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 20V8H18V17C18 17.7956 17.6839 18.5587 17.1213 19.1213C16.5587 19.6839 15.7956 20 15 20H9ZM7 20H3C2.20435 20 1.44129 19.6839 0.87868 19.1213C0.31607 18.5587 0 17.7956 0 17L0 8H7V20ZM18 6H0V3C0 2.20435 0.31607 1.44129 0.87868 0.87868C1.44129 0.31607 2.20435 0 3 0L15 0C15.7956 0 16.5587 0.31607 17.1213 0.87868C17.6839 1.44129 18 2.20435 18 3V6Z"
        fill={props.fill ?? "#858585"}
      />
    </svg>
  )
}

function ArrowLeft(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19 12H5"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M12 19L5 12L12 5"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function ArrowRight(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5 12H19"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M12 5L19 12L12 19"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function ChevronLeft(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 18L9 12L15 6"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function ChevronRight(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 18L15 12L9 6"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function ChevronDown(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 9L12 15L18 9"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function ChevronUp(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18 15L12 9L6 15"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Check(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 6L9 17L4 12"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Close(props: SVGProps<SVGSVGElement>) {
  return <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18 6L6 18"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M6 6L18 18"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Edit(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M18.5 2.5C18.8978 2.10217 19.4374 1.87868 20 1.87868C20.5626 1.87868 21.1022 2.10217 21.5 2.5C21.8978 2.89782 22.1213 3.43739 22.1213 4C22.1213 4.56261 21.8978 5.10217 21.5 5.5L12 15L8 16L9 12L18.5 2.5Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function DownloadTimeData(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M12 6V12L16 14"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Import(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M14 16L8 16L8 10"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M19 5L8 16"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Export(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M15 3H21V9"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M10 14L21 3"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Settings(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M18.7273 14.7273C18.6063 15.0015 18.5702 15.3056 18.6236 15.6005C18.6771 15.8954 18.8177 16.1676 19.0273 16.3818L19.0818 16.4364C19.2509 16.6052 19.385 16.8057 19.4765 17.0265C19.568 17.2472 19.6151 17.4838 19.6151 17.7227C19.6151 17.9617 19.568 18.1983 19.4765 18.419C19.385 18.6397 19.2509 18.8402 19.0818 19.0091C18.913 19.1781 18.7124 19.3122 18.4917 19.4037C18.271 19.4952 18.0344 19.5423 17.7955 19.5423C17.5565 19.5423 17.3199 19.4952 17.0992 19.4037C16.8785 19.3122 16.678 19.1781 16.5091 19.0091L16.4545 18.9545C16.2403 18.745 15.9682 18.6044 15.6733 18.5509C15.3784 18.4974 15.0742 18.5335 14.8 18.6545C14.5311 18.7698 14.3018 18.9611 14.1403 19.205C13.9788 19.4489 13.8921 19.7347 13.8909 20.0273V20.1818C13.8909 20.664 13.6994 21.1265 13.3584 21.4675C13.0174 21.8084 12.5549 22 12.0727 22C11.5905 22 11.1281 21.8084 10.7871 21.4675C10.4461 21.1265 10.2545 20.664 10.2545 20.1818V20.1C10.2475 19.7991 10.1501 19.5073 9.97501 19.2625C9.79991 19.0176 9.55521 18.8312 9.27273 18.7273C8.99853 18.6063 8.69437 18.5702 8.39947 18.6236C8.10456 18.6771 7.83244 18.8177 7.61818 19.0273L7.56364 19.0818C7.39478 19.2509 7.19425 19.385 6.97353 19.4765C6.7528 19.568 6.51621 19.6151 6.27727 19.6151C6.03834 19.6151 5.80174 19.568 5.58102 19.4765C5.36029 19.385 5.15977 19.2509 4.99091 19.0818C4.82186 18.913 4.68775 18.7124 4.59626 18.4917C4.50476 18.271 4.45766 18.0344 4.45766 17.7955C4.45766 17.5565 4.50476 17.3199 4.59626 17.0992C4.68775 16.8785 4.82186 16.678 4.99091 16.5091L5.04545 16.4545C5.25503 16.2403 5.39562 15.9682 5.4491 15.6733C5.50257 15.3784 5.46647 15.0742 5.34545 14.8C5.23022 14.5311 5.03887 14.3018 4.79497 14.1403C4.55107 13.9788 4.26526 13.8921 3.97273 13.8909H3.81818C3.33597 13.8909 2.87351 13.6994 2.53253 13.3584C2.19156 13.0174 2 12.5549 2 12.0727C2 11.5905 2.19156 11.1281 2.53253 10.7871C2.87351 10.4461 3.33597 10.2545 3.81818 10.2545H3.9C4.2009 10.2475 4.49273 10.1501 4.73754 9.97501C4.98236 9.79991 5.16883 9.55521 5.27273 9.27273C5.39374 8.99853 5.42984 8.69437 5.37637 8.39947C5.3229 8.10456 5.18231 7.83244 4.97273 7.61818L4.91818 7.56364C4.74913 7.39478 4.61503 7.19425 4.52353 6.97353C4.43203 6.7528 4.38493 6.51621 4.38493 6.27727C4.38493 6.03834 4.43203 5.80174 4.52353 5.58102C4.61503 5.36029 4.74913 5.15977 4.91818 4.99091C5.08704 4.82186 5.28757 4.68775 5.50829 4.59626C5.72901 4.50476 5.96561 4.45766 6.20455 4.45766C6.44348 4.45766 6.68008 4.50476 6.9008 4.59626C7.12152 4.68775 7.32205 4.82186 7.49091 4.99091L7.54545 5.04545C7.75971 5.25503 8.03183 5.39562 8.32674 5.4491C8.62164 5.50257 8.9258 5.46647 9.2 5.34545H9.27273C9.54161 5.23022 9.77092 5.03887 9.93245 4.79497C10.094 4.55107 10.1807 4.26526 10.1818 3.97273V3.81818C10.1818 3.33597 10.3734 2.87351 10.7144 2.53253C11.0553 2.19156 11.5178 2 12 2C12.4822 2 12.9447 2.19156 13.2856 2.53253C13.6266 2.87351 13.8182 3.33597 13.8182 3.81818V3.9C13.8193 4.19253 13.906 4.47834 14.0676 4.72224C14.2291 4.96614 14.4584 5.15749 14.7273 5.27273C15.0015 5.39374 15.3056 5.42984 15.6005 5.37637C15.8954 5.3229 16.1676 5.18231 16.3818 4.97273L16.4364 4.91818C16.6052 4.74913 16.8057 4.61503 17.0265 4.52353C17.2472 4.43203 17.4838 4.38493 17.7227 4.38493C17.9617 4.38493 18.1983 4.43203 18.419 4.52353C18.6397 4.61503 18.8402 4.74913 19.0091 4.91818C19.1781 5.08704 19.3122 5.28757 19.4037 5.50829C19.4952 5.72901 19.5423 5.96561 19.5423 6.20455C19.5423 6.44348 19.4952 6.68008 19.4037 6.9008C19.3122 7.12152 19.1781 7.32205 19.0091 7.49091L18.9545 7.54545C18.745 7.75971 18.6044 8.03183 18.5509 8.32674C18.4974 8.62164 18.5335 8.9258 18.6545 9.2V9.27273C18.7698 9.54161 18.9611 9.77092 19.205 9.93245C19.4489 10.094 19.7347 10.1807 20.0273 10.1818H20.1818C20.664 10.1818 21.1265 10.3734 21.4675 10.7144C21.8084 11.0553 22 11.5178 22 12C22 12.4822 21.8084 12.9447 21.4675 13.2856C21.1265 13.6266 20.664 13.8182 20.1818 13.8182H20.1C19.8075 13.8193 19.5217 13.906 19.2778 14.0676C19.0339 14.2291 18.8425 14.4584 18.7273 14.7273V14.7273Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Minus(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5 12H19"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Plus(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 5V19"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M5 12H19"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function PlusCircle(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M12 8V16"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M8 12H16"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Eye(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function EyeOff(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.12 14.12C13.8454 14.4147 13.5141 14.6511 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1752 15.0074 10.8016 14.8565C10.4281 14.7056 10.0887 14.481 9.80385 14.1961C9.51897 13.9113 9.29439 13.5719 9.14351 13.1984C8.99262 12.8248 8.91853 12.4247 8.92563 12.0219C8.93274 11.6191 9.02091 11.2218 9.18488 10.8538C9.34884 10.4858 9.58525 10.1546 9.88 9.87999M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.68189 3.96914 7.6566 6.06 6.05999L17.94 17.94ZM9.9 4.23999C10.5883 4.07887 11.2931 3.99833 12 3.99999C19 3.99999 23 12 23 12C22.393 13.1356 21.6691 14.2047 20.84 15.19L9.9 4.23999Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M1 1L23 23"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function NotificationsFilled(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <path
      d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
      fill={props.fill ?? "#1D1D1E"}
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M13.73 21C13.5542 21.3031 13.3018 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6981 21.5547 10.4458 21.3031 10.27 21"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Notifications(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
      stroke={props.fill ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M13.73 21C13.5542 21.3031 13.3018 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6981 21.5547 10.4458 21.3031 10.27 21"
      stroke={props.fill ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function FavoriteFilled(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <path
      d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
      fill={props.fill ?? "#1D1D1E"}
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function FavoriteOutlined(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function DeleteOutlined(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 6H5H21"
      stroke={props.stroke ?? "#FF5230"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
      stroke={props.stroke ?? "#FF5230"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Mute(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 5L6 9H2V15H6L11 19V5Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M23 9L17 15"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M17 9L23 15"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function ChatOutlined(props: SVGProps<SVGSVGElement>) {
  return <svg
    width={props.width ?? 24}
    height={props.height ?? 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21 11.5C21.0034 12.8199 20.6951 14.1219 20.1 15.3C19.3944 16.7117 18.3098 17.8992 16.9674 18.7293C15.6251 19.5594 14.0782 19.9994 12.5 20C11.1801 20.0034 9.87812 19.6951 8.7 19.1L3 21L4.9 15.3C4.30493 14.1219 3.99656 12.8199 4 11.5C4.00061 9.92176 4.44061 8.37485 5.27072 7.03255C6.10083 5.69025 7.28825 4.60557 8.7 3.9C9.87812 3.30493 11.1801 2.99656 12.5 3H13C15.0843 3.11499 17.053 3.99476 18.5291 5.47086C20.0052 6.94695 20.885 8.91565 21 11V11.5Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Send(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22 2 11 13M22 2l-7 20-4-9-9-4 20-7Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
}

function Info(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M12 16V12"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M12 8H12.01"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Video(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M23 7L16 12L23 17V7Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M14 5H3C1.89543 5 1 5.89543 1 7V17C1 18.1046 1.89543 19 3 19H14C15.1046 19 16 18.1046 16 17V7C16 5.89543 15.1046 5 14 5Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Phone(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22 16.92V19.92C22.0011 20.1985 21.9441 20.4742 21.8325 20.7294C21.7209 20.9845 21.5573 21.2136 21.3521 21.4019C21.1468 21.5901 20.9046 21.7335 20.6407 21.8227C20.3769 21.9119 20.0974 21.9451 19.82 21.92C16.7428 21.5856 13.787 20.5342 11.19 18.85C8.77382 17.3147 6.72533 15.2662 5.18999 12.85C3.49997 10.2412 2.44824 7.271 2.11999 4.18001C2.095 3.90347 2.12787 3.62477 2.21649 3.36163C2.30512 3.09849 2.44756 2.85669 2.63476 2.65163C2.82196 2.44656 3.0498 2.28271 3.30379 2.17053C3.55777 2.05834 3.83233 2.00027 4.10999 2.00001H7.10999C7.5953 1.99523 8.06579 2.16708 8.43376 2.48354C8.80173 2.79999 9.04207 3.23945 9.10999 3.72001C9.23662 4.68007 9.47144 5.62273 9.80999 6.53001C9.94454 6.88793 9.97366 7.27692 9.8939 7.65089C9.81415 8.02485 9.62886 8.36812 9.35999 8.64001L8.08999 9.91001C9.51355 12.4136 11.5864 14.4865 14.09 15.91L15.36 14.64C15.6319 14.3711 15.9751 14.1859 16.3491 14.1061C16.7231 14.0263 17.1121 14.0555 17.47 14.19C18.3773 14.5286 19.3199 14.7634 20.28 14.89C20.7658 14.9585 21.2094 15.2032 21.5265 15.5775C21.8437 15.9518 22.0122 16.4296 22 16.92Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Attach(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.44 11.05L12.25 20.24C11.1242 21.3658 9.59718 21.9983 8.005 21.9983C6.41282 21.9983 4.88584 21.3658 3.76 20.24C2.63416 19.1142 2.00166 17.5872 2.00166 15.995C2.00166 14.4028 2.63416 12.8758 3.76 11.75L12.95 2.56C13.7006 1.80943 14.7185 1.38777 15.78 1.38777C16.8415 1.38777 17.8594 1.80943 18.61 2.56C19.3606 3.31056 19.7822 4.32854 19.7822 5.39C19.7822 6.45145 19.3606 7.46943 18.61 8.22L9.41 17.41C9.03472 17.7853 8.52573 17.9961 7.995 17.9961C7.46427 17.9961 6.95528 17.7853 6.58 17.41C6.20472 17.0347 5.99389 16.5257 5.99389 15.995C5.99389 15.4643 6.20472 14.9553 6.58 14.58L15.07 6.1"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Teams(props: SVGProps<SVGSVGElement>) {
  return <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <path
      d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function AddUser(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M8.5 11C10.7091 11 12.5 9.20914 12.5 7C12.5 4.79086 10.7091 3 8.5 3C6.29086 3 4.5 4.79086 4.5 7C4.5 9.20914 6.29086 11 8.5 11Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M20 8V14"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M23 11H17"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function RemoveUser(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M8.5 11C10.7091 11 12.5 9.20914 12.5 7C12.5 4.79086 10.7091 3 8.5 3C6.29086 3 4.5 4.79086 4.5 7C4.5 9.20914 6.29086 11 8.5 11Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M23 11H17"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function User(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Filter(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22 3H2L10 12.46V19L14 21V12.46L22 3Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Search(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M21 21L16.65 16.65"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Calendar(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M16 2V6"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M8 2V6"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M3 10H21"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Collapse(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 14H10V20"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M20 10H14V4"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M14 10L21 3"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M3 21L10 14"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Expand(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 3H21V9"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M9 21H3V15"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M21 3L14 10"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M3 21L10 14"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function MoreHorizontal(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 10C3.89543 10 3 10.8954 3 12C3 13.1046 3.89543 14 5 14C6.10457 14 7 13.1046 7 12C7 10.8954 6.10457 10 5 10ZM10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12ZM17 12C17 10.8954 17.8954 10 19 10C20.1046 10 21 10.8954 21 12C21 13.1046 20.1046 14 19 14C17.8954 14 17 13.1046 17 12Z"
      fill={props.fill ?? "#1D1D1E"}/>
  </svg>
}

function MoreVertical(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <path
      fillRule="evenodd" clipRule="evenodd"
      d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6ZM12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13ZM13 19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19C11 18.4477 11.4477 18 12 18C12.5523 18 13 18.4477 13 19Z"
      fill={props.fill ?? "#1D1D1E"}/>
    <path
      d="M12 5V7C13.1046 7 14 6.10457 14 5H12ZM12 5H14C14 3.89543 13.1046 3 12 3V5ZM12 5V3C10.8954 3 10 3.89543 10 5H12ZM12 5H10C10 6.10457 10.8954 7 12 7V5ZM12 12V14C13.1046 14 14 13.1046 14 12H12ZM12 12H14C14 10.8954 13.1046 10 12 10V12ZM12 12V10C10.8954 10 10 10.8954 10 12H12ZM12 12H10C10 13.1046 10.8954 14 12 14V12ZM12 21C13.1046 21 14 20.1046 14 19H12V21ZM10 19C10 20.1046 10.8954 21 12 21V19H10ZM12 17C10.8954 17 10 17.8954 10 19H12V17ZM14 19C14 17.8954 13.1046 17 12 17V19H14Z"
      fill={props.fill ?? "#1D1D1E"}/>
  </svg>
}

function Menu(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 12H21"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M3 6H21"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M3 18H21"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Location(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.6362 4.66905C7.32401 2.96009 9.61317 2 12.0001 2C14.387 2 16.6762 2.96009 18.364 4.66905C20.0518 6.37801 21 8.69586 21 11.1127C21 13.5295 20.0518 15.8474 18.364 17.5563L12.0001 24L5.6362 17.5563C4.80043 16.7102 4.13745 15.7056 3.68513 14.6C3.23281 13.4944 3 12.3094 3 11.1127C3 9.91598 3.23281 8.73099 3.68513 7.62538C4.13745 6.51978 4.80043 5.51521 5.6362 4.66905ZM12.0001 13.7162C12.682 13.7162 13.3361 13.4419 13.8183 12.9536C14.3005 12.4654 14.5714 11.8032 14.5714 11.1127C14.5714 10.4222 14.3005 9.76 13.8183 9.27175C13.3361 8.7835 12.682 8.5092 12.0001 8.5092C11.3182 8.5092 10.6641 8.7835 10.1819 9.27175C9.69973 9.76 9.42882 10.4222 9.42882 11.1127C9.42882 11.8032 9.69973 12.4654 10.1819 12.9536C10.6641 13.4419 11.3182 13.7162 12.0001 13.7162Z"
      fill={props.fill ?? "#CBCBCB"}/>
  </svg>
}

function Pin(props: SVGProps<SVGSVGElement>) {
  return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_13270_17579)">
      <mask id="path-1-inside-1_13270_17579" fill="white">
        <path
          d="M15.5621 19.8301C16.5811 18.0651 16.4513 15.914 15.424 14.0693L18.964 7.9378L19.397 8.1878C19.7416 8.38671 20.151 8.44061 20.5353 8.33765C20.9195 8.23468 21.2472 7.98329 21.4461 7.63876C21.645 7.29423 21.6989 6.8848 21.5959 6.50053C21.493 6.11626 21.2416 5.78863 20.897 5.58972L13.1028 1.08972C12.7583 0.890809 12.3488 0.836906 11.9646 0.939871C11.5803 1.04284 11.2527 1.29423 11.0538 1.63876C10.8549 1.98329 10.801 2.39272 10.9039 2.77699C11.0069 3.16126 11.2583 3.48889 11.6028 3.6878L12.0358 3.9378L8.49582 10.0693C6.38458 10.102 4.45674 11.0651 3.43774 12.8301L8.6339 15.8301L6.6339 19.2942C6.3589 19.7705 6.52361 20.3852 6.99992 20.6602C7.47624 20.9352 8.09095 20.7705 8.36595 20.2942L10.3659 16.8301L15.5621 19.8301Z"/>
      </mask>
      <path
        d="M15.5621 19.8301C16.5811 18.0651 16.4513 15.914 15.424 14.0693L18.964 7.9378L19.397 8.1878C19.7416 8.38671 20.151 8.44061 20.5353 8.33765C20.9195 8.23468 21.2472 7.98329 21.4461 7.63876C21.645 7.29423 21.6989 6.8848 21.5959 6.50053C21.493 6.11626 21.2416 5.78863 20.897 5.58972L13.1028 1.08972C12.7583 0.890809 12.3488 0.836906 11.9646 0.939871C11.5803 1.04284 11.2527 1.29423 11.0538 1.63876C10.8549 1.98329 10.801 2.39272 10.9039 2.77699C11.0069 3.16126 11.2583 3.48889 11.6028 3.6878L12.0358 3.9378L8.49582 10.0693C6.38458 10.102 4.45674 11.0651 3.43774 12.8301L8.6339 15.8301L6.6339 19.2942C6.3589 19.7705 6.52361 20.3852 6.99992 20.6602C7.47624 20.9352 8.09095 20.7705 8.36595 20.2942L10.3659 16.8301L15.5621 19.8301Z"
        stroke={props.stroke ?? "#1D1D1E"} strokeWidth="4" mask="url(#path-1-inside-1_13270_17579)"/>
    </g>
    <defs>
      <clipPath id="clip0_13270_17579">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
}

function PinFilled(props: SVGProps<SVGSVGElement>) {
  return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="System / Pin-filled" clipPath="url(#clip0_22_239)">
      <g id="Vector">
        <mask id="path-1-inside-1_22_239" fill="white">
          <path
            d="M15.5622 19.8301C16.5812 18.0652 16.4513 15.9141 15.4241 14.0693L18.9641 7.93782L19.3971 8.18782C19.7416 8.38673 20.1511 8.44064 20.5353 8.33767C20.9196 8.23471 21.2472 7.98331 21.4461 7.63878C21.645 7.29426 21.6989 6.88482 21.596 6.50055C21.493 6.11628 21.2416 5.78866 20.8971 5.58974L13.1029 1.08974C12.7583 0.890832 12.3489 0.836929 11.9646 0.939894C11.5804 1.04286 11.2527 1.29426 11.0538 1.63878C10.8549 1.98331 10.801 2.39274 10.904 2.77701C11.0069 3.16128 11.2583 3.48891 11.6029 3.68782L12.0359 3.93782L8.49588 10.0693C6.38464 10.1021 4.45681 11.0652 3.43781 12.8301L8.63396 15.8301L6.63396 19.2942C6.35896 19.7705 6.52367 20.3853 6.99998 20.6603C7.4763 20.9353 8.09101 20.7705 8.36601 20.2942L10.366 16.8301L15.5622 19.8301Z"/>
        </mask>
        <path
          d="M15.5622 19.8301C16.5812 18.0652 16.4513 15.9141 15.4241 14.0693L18.9641 7.93782L19.3971 8.18782C19.7416 8.38673 20.1511 8.44064 20.5353 8.33767C20.9196 8.23471 21.2472 7.98331 21.4461 7.63878C21.645 7.29426 21.6989 6.88482 21.596 6.50055C21.493 6.11628 21.2416 5.78866 20.8971 5.58974L13.1029 1.08974C12.7583 0.890832 12.3489 0.836929 11.9646 0.939894C11.5804 1.04286 11.2527 1.29426 11.0538 1.63878C10.8549 1.98331 10.801 2.39274 10.904 2.77701C11.0069 3.16128 11.2583 3.48891 11.6029 3.68782L12.0359 3.93782L8.49588 10.0693C6.38464 10.1021 4.45681 11.0652 3.43781 12.8301L8.63396 15.8301L6.63396 19.2942C6.35896 19.7705 6.52367 20.3853 6.99998 20.6603C7.4763 20.9353 8.09101 20.7705 8.36601 20.2942L10.366 16.8301L15.5622 19.8301Z"
          fill={props.fill ?? "#1D1D1E"}
          stroke={props.stroke ?? "#1D1D1E"}
          strokeWidth="4"
          mask="url(#path-1-inside-1_22_239)"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_22_239">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
}

function Unpin(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <g clipPath="url(#clip0_426_9)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.80401 5.1961C3.32572 4.91996 3.16185 4.30837 3.43799 3.83008C3.71413 3.35178 4.32572 3.18791 4.80401 3.46405L23.1505 14.0564C23.6288 14.3326 23.7927 14.9441 23.5165 15.4224C23.2404 15.9007 22.6288 16.0646 22.1505 15.7885L3.80401 5.1961Z"
        fill={props.fill ?? "#1D1D1E"}/>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25788 10.0769C6.9622 10.1405 5.74702 10.5575 4.78363 11.2977C4.24705 11.71 3.78858 12.2226 3.43781 12.8301L5.16986 13.8301L6.90191 14.8301L8.63396 15.8301L7.63396 17.5622L6.63396 19.2942C6.35896 19.7705 6.52367 20.3853 6.99998 20.6603C7.4763 20.9353 8.09101 20.7705 8.36601 20.2942L9.36601 18.5622L10.366 16.8301L12.0981 17.8301L13.8301 18.8301L15.5622 19.8301C15.9129 19.2226 16.1276 18.5692 16.2163 17.8984C16.3757 16.694 16.1293 15.4331 15.5364 14.2792L13.6292 13.1781L13.125 14.0514L13.6767 15.0423C13.9961 15.6158 14.1811 16.1978 14.2414 16.7582L11.366 15.0981L9.63396 14.0981L6.75853 12.4379C7.27399 12.21 7.87059 12.0792 8.52692 12.069L9.66088 12.0514L10.1651 11.1781L8.25788 10.0769ZM14.6292 11.446L16.3613 12.446L17.3613 10.714L15.6292 9.71399L14.6292 11.446ZM12.1651 7.71399L11.1651 9.44604L9.43306 8.44604L10.4331 6.71399L12.1651 7.71399ZM16.6292 7.98194L17.232 6.93782L17.732 6.0718L14.2679 4.0718L13.7679 4.93782L13.1651 5.98194L11.4331 4.98194L12.0359 3.93782L11.6029 3.68782C11.2583 3.48891 11.0069 3.16128 10.904 2.77701C10.801 2.39274 10.8549 1.98331 11.0538 1.63878C11.2527 1.29426 11.5804 1.04286 11.9646 0.939894C12.3489 0.836929 12.7583 0.890832 13.1029 1.08974L20.8971 5.58974C21.2416 5.78866 21.493 6.11628 21.596 6.50055C21.6989 6.88482 21.645 7.29426 21.4461 7.63878C21.2472 7.98331 20.9196 8.23471 20.5353 8.33767C20.1511 8.44064 19.7416 8.38673 19.3971 8.18782L18.9641 7.93782L18.3613 8.98194L16.6292 7.98194Z"
        fill={props.fill ?? "#1D1D1E"}/>
    </g>
    <defs>
      <clipPath id="clip0_426_9">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>

}

function ChatFilled(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21 11.5C21.0034 12.8199 20.6951 14.1219 20.1 15.3C19.3944 16.7117 18.3098 17.8992 16.9674 18.7293C15.6251 19.5594 14.0782 19.9994 12.5 20C11.1801 20.0034 9.87812 19.6951 8.7 19.1L3 21L4.9 15.3C4.30493 14.1219 3.99656 12.8199 4 11.5C4.00061 9.92176 4.44061 8.37485 5.27072 7.03255C6.10083 5.69025 7.28825 4.60557 8.7 3.9C9.87812 3.30493 11.1801 2.99656 12.5 3H13C15.0843 3.11499 17.053 3.99476 18.5291 5.47086C20.0052 6.94695 20.885 8.91565 21 11V11.5Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Play(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <path
      d="M5 3L19 12L5 21V3Z"
      fill={props.fill ?? "#1D1D1E"}
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Pause(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <path
      d="M9 4H5V20H9V4Z"
      fill={props.fill ?? "#1D1D1E"}
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M19 4H15V20H19V4Z"
      fill={props.fill ?? "#1D1D1E"}
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Stop(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <path
      d="M20 4H4V20H20V4Z"
      fill={props.fill ?? "#1D1D1E"}
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function LockFilled(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <path
      d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z"
      fill={props.fill ?? "#1D1D1E"}
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M7.00195 10.9995V6.99951C7.00195 5.67343 7.52874 4.40166 8.46642 3.46398C9.4041 2.5263 10.6759 1.99951 12.002 1.99951C13.328 1.99951 14.5998 2.5263 15.5375 3.46398C16.4752 4.40166 17.002 5.67343 17.002 6.99951V10.9995"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function LockOutlined(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M7.00195 10.9995V6.99951C7.00195 5.67343 7.52874 4.40166 8.46642 3.46398C9.4041 2.5263 10.6759 1.99951 12.002 1.99951C13.328 1.99951 14.5998 2.5263 15.5375 3.46398C16.4752 4.40166 17.002 5.67343 17.002 6.99951V10.9995"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Arrow_Right(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <path
      d="M5 11.3599V4.63968C5 4.14656 5.45602 3.83932 5.81915 4.08778L10.7298 7.44789C11.0901 7.69444 11.0901 8.30513 10.7298 8.55168L5.81915 11.9118C5.45603 12.1603 5 11.853 5 11.3599Z"
      fill={props.fill ?? "#CBCBCB"}/>
  </svg>
}

function Tips(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <circle cx="12" cy="12" r="10" stroke={props.stroke ?? "#1D1D1E"} strokeWidth={props.strokeWidth ?? "2"}/>
    <path
      d="M13 18.5H11V16.5H13V18.5ZM13 15H11C11 11.75 14 12 14 10C14 8.9 13.1 8 12 8C10.9 8 10 8.9 10 10H8C8 7.79 9.79 6 12 6C14.21 6 16 7.79 16 10C16 12.5 13 12.75 13 15Z"
      fill={props.fill ?? "#1D1D1E"}/>
  </svg>
}

function Camera(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M23 19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H7L9 3H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V19Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function SwitchCamera(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="32"
    height="26"
    viewBox="0 0 32 26"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <path
      d="M31 22.3333C31 23.0406 30.7127 23.7189 30.2012 24.219C29.6897 24.719 28.996 25 28.2727 25H3.72727C3.00396 25 2.31026 24.719 1.7988 24.219C1.28734 23.7189 1 23.0406 1 22.3333V7.66667C1 6.95942 1.28734 6.28115 1.7988 5.78105C2.31026 5.28095 3.00396 5 3.72727 5H9.18182L11.9091 1H20.0909L22.8182 5H28.2727C28.996 5 29.6897 5.28095 30.2012 5.78105C30.7127 6.28115 31 6.95942 31 7.66667V22.3333Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.3014 8.11758C15.2953 7.83009 16.3458 7.79906 17.3549 8.02739C18.3641 8.25572 19.2989 8.73597 20.0723 9.42332C20.8456 10.1107 21.4322 10.9827 21.7774 11.9581C21.9386 12.4137 21.7 12.9137 21.2444 13.0749C20.7888 13.2361 20.2888 12.9975 20.1276 12.5419C19.8811 11.8452 19.4621 11.2223 18.9097 10.7313C18.3573 10.2404 17.6896 9.89734 16.9687 9.73425C16.2479 9.57115 15.4975 9.59331 14.7876 9.79866C14.1119 9.9941 13.2323 10.5673 12.6814 11.1186C12.4614 11.3387 12.2152 11.6531 11.9965 11.9583H13.9583C14.4416 11.9583 14.8333 12.3501 14.8333 12.8333C14.8333 13.3166 14.4416 13.7083 13.9583 13.7083H10.4583C9.97509 13.7083 9.58334 13.3166 9.58334 12.8333V9.33333C9.58334 8.85008 9.97509 8.45833 10.4583 8.45833C10.9416 8.45833 11.3333 8.85008 11.3333 9.33333V9.99538C11.37 9.95638 11.4068 9.91832 11.4436 9.88144C12.1466 9.17817 13.2732 8.41498 14.3014 8.11758ZM18.0417 14.2917C17.5584 14.2917 17.1667 14.6834 17.1667 15.1667C17.1667 15.6499 17.5584 16.0417 18.0417 16.0417H19.8726C19.6287 16.504 19.303 16.9205 18.9097 17.27C18.3573 17.761 17.6896 18.104 16.9687 18.2671C16.2479 18.4302 15.4975 18.4081 14.7876 18.2027C14.1119 18.0073 13.2323 17.4341 12.6814 16.8828C12.4247 16.626 12.1323 16.2407 11.8895 15.8915C11.7718 15.7224 11.6724 15.5713 11.6027 15.463C11.5679 15.4089 11.5407 15.3658 11.5225 15.3368L11.5023 15.3043L11.4976 15.2967L11.4968 15.2954C11.2449 14.883 10.7064 14.7528 10.294 15.0046C9.88158 15.2564 9.75138 15.7949 10.0032 16.2074L10.0043 16.2091L10.0064 16.2125L10.0134 16.224L10.0389 16.2649C10.0607 16.2997 10.0919 16.3492 10.1312 16.4102C10.2096 16.532 10.3207 16.7009 10.4528 16.8908C10.7095 17.2598 11.0734 17.7495 11.4436 18.1199C12.1466 18.8232 13.2732 19.5864 14.3014 19.8838C15.2953 20.1713 16.3458 20.2023 17.3549 19.974C18.3641 19.7457 19.2989 19.2654 20.0723 18.5781C20.2849 18.3891 20.4834 18.1861 20.6667 17.9709V18.6667C20.6667 19.1499 21.0584 19.5417 21.5417 19.5417C22.0249 19.5417 22.4167 19.1499 22.4167 18.6667V15.1667C22.4167 14.6834 22.0249 14.2917 21.5417 14.2917H18.0417Z"
      fill={props.fill ?? "#1D1D1E"}/>
  </svg>
}

function Share(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 12V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V12"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M16 6L12 2L8 6"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M12 2V15"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Retake(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <path
      d="M17 1L21 5L17 9"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M3 11V9C3 7.93913 3.42143 6.92172 4.17157 6.17157C4.92172 5.42143 5.93913 5 7 5H21"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M7 23L3 19L7 15"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M21 13V15C21 16.0609 20.5786 17.0783 19.8284 17.8284C19.0783 18.5786 18.0609 19 17 19H3"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Retry(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 4V10H7"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M23 20V14H17"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M20.49 9C19.9828 7.56678 19.1209 6.2854 17.9845 5.27542C16.8482 4.26543 15.4745 3.55976 13.9917 3.22426C12.5089 2.88875 10.9652 2.93434 9.50481 3.35677C8.04437 3.77921 6.71475 4.56471 5.64 5.64L1 10M23 14L18.36 18.36C17.2853 19.4353 15.9556 20.2208 14.4952 20.6432C13.0348 21.0657 11.4911 21.1112 10.0083 20.7757C8.52547 20.4402 7.1518 19.7346 6.01547 18.7246C4.87913 17.7146 4.01717 16.4332 3.51 15"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Move(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5 9L2 12L5 15"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M9 5L12 2L15 5"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M15 19L12 22L9 19"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M19 9L22 12L19 15"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M2 12H22"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M12 2V22"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Offline(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.7258 16.5375C22.0212 15.8402 22.1391 15.0806 22.0692 14.3266C21.9992 13.5725 21.7435 12.8476 21.3249 12.2165C20.9063 11.5854 20.3379 11.0679 19.6704 10.7102C19.003 10.3525 18.2573 10.1658 17.5 10.1667H16.345C15.9708 8.69312 15.1479 7.37229 13.9901 6.38694C12.8323 5.40159 11.3969 4.80044 9.8825 4.66667M5.58333 5.58334C4.15157 6.37501 3.02566 7.62272 2.3847 9.128C1.74375 10.6333 1.62457 12.3097 2.04612 13.8905C2.46767 15.4713 3.40574 16.8658 4.71111 17.852C6.01647 18.8383 7.61415 19.3597 9.25 19.3333H17.5C18.0315 19.3327 18.5588 19.2397 19.0583 19.0583"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M1.91666 1.91667L22.0833 22.0833"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function ReadMessage(props: SVGProps<SVGSVGElement>) {
  return <svg
    width={16}
    height={16}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.0003 0.666016L4.00033 7.99935L0.666992 4.66602"
      stroke={props.stroke ?? "#2B8DFF"}
      strokeWidth={props.strokeWidth ?? "2"}/>
    <path
      d="M15.0003 0.666016L9.00033 7.99935L7.21094 6.5"
      stroke={props.stroke ?? "#2B8DFF"}
      strokeWidth={props.strokeWidth ?? "2"}/>
  </svg>
}

function NameOnly(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_135_50)">
      <path
        d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
        stroke={props.stroke ?? "#1D1D1E"}
        strokeWidth={props.strokeWidth ?? "2"}
        strokeLinecap="round"
        strokeLinejoin="round"/>
      <path
        d="M7 11H11"
        stroke={props.stroke ?? "#1D1D1E"}
        strokeWidth={props.strokeWidth ?? "2"}
        strokeLinecap="round"
        strokeLinejoin="round"/>
      <path
        d="M7 16H17"
        stroke={props.stroke ?? "#1D1D1E"}
        strokeWidth={props.strokeWidth ?? "2"}
        strokeLinecap="round"
        strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_135_50">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
}

function NameOnlyFilled(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <path
      d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
      fill={props.fill ?? "#1D1D1E"}
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M7 11H11"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M7 16H17"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Navigation(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 11L22 2L13 21L11 13L3 11Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function NavigationFilled(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <path
      d="M3 11L22 2L13 21L11 13L3 11Z"
      fill={props.fill ?? "#1D1D1E"}
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Login(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H15"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M10 17L15 12L10 7"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M15 12H3"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Logout(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9"
      stroke={props.stroke ?? "#FF5230"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M16 17L21 12L16 7"
      stroke={props.stroke ?? "#FF5230"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M21 12H9"
      stroke={props.stroke ?? "#FF5230"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Volume1(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 5L6 9H2V15H6L11 19V5Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M15.54 8.46C16.4773 9.39764 17.0039 10.6692 17.0039 11.995C17.0039 13.3208 16.4773 14.5924 15.54 15.53"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Volume2(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 5L6 9H2V15H6L11 19V5Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M19.07 4.93C20.9447 6.80528 21.9979 9.34836 21.9979 12C21.9979 14.6516 20.9447 17.1947 19.07 19.07M15.54 8.46C16.4774 9.39764 17.0039 10.6692 17.0039 11.995C17.0039 13.3208 16.4774 14.5924 15.54 15.53"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Language(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M2 12H22"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22C9.49872 19.2616 8.07725 15.708 8 12C8.07725 8.29203 9.49872 4.73835 12 2V2Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Database(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 8C16.9706 8 21 6.65685 21 5C21 3.34315 16.9706 2 12 2C7.02944 2 3 3.34315 3 5C3 6.65685 7.02944 8 12 8Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M21 12C21 13.66 17 15 12 15C7 15 3 13.66 3 12"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M3 5V19C3 20.66 7 22 12 22C17 22 21 20.66 21 19V5"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Mail(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M22 6L12 13L2 6"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function AlertCircle(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke={props.stroke ?? "#FF5230"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M12 8V12"
      stroke={props.stroke ?? "#FF5230"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M12 16H12.01"
      stroke={props.stroke ?? "#FF5230"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function CloseCircle(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke={props.stroke ?? "#FF5230"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M15 9L9 15"
      stroke={props.stroke ?? "#FF5230"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M9 9L15 15"
      stroke={props.stroke ?? "#FF5230"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function CheckCircle(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke={props.stroke ?? "#3CB877"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M16 10L11 15.01L8 12.01"
      stroke={props.stroke ?? "#3CB877"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Upload(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
      stroke={props.stroke ?? "#2B8DFF"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M17 8L12 3L7 8"
      stroke={props.stroke ?? "#2B8DFF"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M12 3V15"
      stroke={props.stroke ?? "#2B8DFF"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Download(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
      stroke={props.stroke ?? "#2B8DFF"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M7 10L12 15L17 10"
      stroke={props.stroke ?? "#2B8DFF"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M12 15V3"
      stroke={props.stroke ?? "#2B8DFF"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Unselected(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12" cy="12" r="11.5" stroke={props.stroke ?? "#CBCBCB"}/>
  </svg>
}

function Selected(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <circle cx="12" cy="12" r="12" fill={props.fill ?? "#2B8DFF"}/>
    <path
      d="M10.7386 15.9416C10.6292 15.9418 10.5209 15.9204 10.4198 15.8787C10.3187 15.8369 10.2268 15.7756 10.1494 15.6983L6.61444 12.1624C6.5348 12.0856 6.47125 11.9937 6.4275 11.8921C6.38376 11.7904 6.36069 11.6811 6.35966 11.5704C6.35862 11.4598 6.37962 11.3501 6.42145 11.2476C6.46328 11.1452 6.52509 11.0521 6.60328 10.9738C6.68147 10.8955 6.77447 10.8335 6.87685 10.7916C6.97923 10.7496 7.08895 10.7284 7.1996 10.7293C7.31025 10.7302 7.41961 10.7531 7.52131 10.7967C7.62301 10.8403 7.71501 10.9037 7.79194 10.9833L10.7378 13.9291L16.0419 8.6266C16.1982 8.47023 16.4102 8.38234 16.6312 8.38226C16.8523 8.38219 17.0643 8.46993 17.2207 8.62618C17.3771 8.78244 17.4649 8.99441 17.465 9.21547C17.4651 9.43653 17.3774 9.64856 17.2211 9.80493L11.3278 15.6983C11.2504 15.7756 11.1586 15.8369 11.0575 15.8787C10.9564 15.9204 10.848 15.9418 10.7386 15.9416Z"
      fill="white"/>
  </svg>
}

function Zap(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13 2L3 14H12L11 22L21 10H12L13 2Z"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function ZapOff(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.41 6.75L13 2L10.57 4.92"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M18.57 12.91L21 10H15.66"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M8 8L3 14H12L11 22L16 16"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M1 1L23 23"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function CloudUpload(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 4C15.64 4 18.67 6.59 19.35 10.04C21.95 10.22 24 12.36 24 15C24 17.76 21.76 20 19 20H6C2.69 20 0 17.31 0 14C0 10.91 2.34 8.36 5.35 8.04C6.6 5.64 9.11 4 12 4ZM7.29289 11.2929L11.2929 7.29289C11.6834 6.90237 12.3166 6.90237 12.7071 7.29289L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071C16.3166 13.0976 15.6834 13.0976 15.2929 12.7071L13 10.4142V17.0909C13 17.593 12.5523 18 12 18C11.4477 18 11 17.593 11 17.0909V10.4142L8.70711 12.7071C8.31658 13.0976 7.68342 13.0976 7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929Z"
      fill={props.fill ?? "#1D1D1E"}/>
  </svg>
}

function CorruptedFileFilled(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 2H13L20 9V13.1667C16.7783 13.1667 14.1667 15.7784 14.1667 19C14.1667 20.0971 14.4695 21.1234 14.9962 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V4C4 3.46957 4.21071 2.96086 4.58579 2.58579C4.96086 2.21071 5.46957 2 6 2ZM13 5.875V4L18 9H13V5.875ZM22.4571 16.5429C22.8476 16.9334 22.8476 17.5666 22.4571 17.9571L21.4142 19L22.4571 20.0429C22.8476 20.4334 22.8476 21.0666 22.4571 21.4571C22.0666 21.8476 21.4334 21.8476 21.0429 21.4571L20 20.4142L18.9571 21.4571C18.5666 21.8476 17.9334 21.8476 17.5429 21.4571C17.1524 21.0666 17.1524 20.4334 17.5429 20.0429L18.5858 19L17.5429 17.9571C17.1524 17.5666 17.1524 16.9334 17.5429 16.5429C17.9334 16.1524 18.5666 16.1524 18.9571 16.5429L20 17.5858L21.0429 16.5429C21.4334 16.1524 22.0666 16.1524 22.4571 16.5429Z"
      fill={props.fill ?? "#1D1D1E"}/>
  </svg>
}

function CorruptedFileOutline(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13 22C9.68054 22 6 22 6 22C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V4C4 3.46957 4.21071 2.96086 4.58579 2.58579C4.96086 2.21071 5.46957 2 6 2H13L20 9V13"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M13 2V9H20"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M21 18L17 22"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
    <path
      d="M17 18L21 22"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? "2"}
      strokeLinecap="round"
      strokeLinejoin="round"/>
  </svg>
}

function Milestone(props: SVGProps<SVGSVGElement>) {
  return <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1v12ZM4 22v-7"
      stroke={props.stroke ?? "#1D1D1E"}
      strokeWidth={props.strokeWidth ?? 2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
}

function LoaderOnWhite(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M12 2V6" stroke="#858585" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 18V22" stroke="#CBCBCB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4.93 4.92999L7.76 7.75999" stroke="#EAEAEA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16.24 16.24L19.07 19.07" stroke="#CBCBCB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2 12H6" stroke="#EAEAEA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18 12H22" stroke="#CBCBCB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4.93 19.07L7.76 16.24" stroke="#EAEAEA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16.24 7.75999L19.07 4.92999" stroke="#858585" strokeWidth="2" strokeLinecap="round"
          strokeLinejoin="round"/>
  </svg>

}

function TextFormat(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        d="M8.667 13.733h6.666l1.2 2.934h2.8L13 2h-2L4.667 16.667h2.8l1.2-2.934ZM12 4.64l2.493 6.693H9.507L12 4.64Z"
        fill="#1D1D1E"
      />
      <path
        d="M20 21H4"
        stroke="#1D1D1E"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

function Paragraph(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        d="M20 12H4M20 6H4M12 18H4"
        stroke="#1D1D1E"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

function Numeric(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
    >
      <g clipPath="url(#a)">
        <path
          d="M3.016 3.172h.332v3.71a.586.586 0 0 0 1.172 0V2.587A.586.586 0 0 0 3.934 2h-.918a.586.586 0 0 0 0 1.172ZM4.894 13.553l-1.034.009c.22-.3.508-.695.874-1.218.277-.396.458-.773.539-1.119a.582.582 0 0 0 .01-.058l.02-.163a.585.585 0 0 0 .006-.074c0-.918-.747-1.664-1.665-1.664-.793 0-1.48.564-1.633 1.342a.586.586 0 0 0 1.15.226.493.493 0 0 1 .975.066l-.011.086c-.037.14-.128.366-.351.686-.667.952-1.064 1.472-1.278 1.752-.27.353-.418.548-.32.866.058.19.201.334.392.398.08.026.143.048.961.048.325 0 .769-.004 1.38-.011a.586.586 0 0 0-.015-1.172ZM3.744 16.531c-.792 0-1.477.563-1.63 1.34a.586.586 0 1 0 1.15.225.489.489 0 1 1 .48.584.586.586 0 0 0 0 1.172.489.489 0 1 1-.489.488.586.586 0 0 0-1.171 0A1.667 1.667 0 0 0 3.744 22c.915 0 1.66-.745 1.66-1.66 0-.41-.15-.785-.396-1.074a1.662 1.662 0 0 0-1.264-2.734Z"
          fill="#1D1D1E"
        />
        <path
          d="M20.333 12h-10M20.333 4.333h-10M20.333 19.667h-10"
          stroke="#1D1D1E"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" transform="translate(2 2)" d="M0 0h20v20H0z"/>
        </clipPath>
      </defs>
    </svg>
  )
}

function Drag(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        d="M3 15h18M3 9h18"
        stroke="#1D1D1E"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

function Unlink(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke={props.stroke ?? "#FF5230"}
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
      <path
        d="M10 14a3.5 3.5 0 0 0 4.47 .444m2.025 -1.94c.557 -.556 1.392 -1.39 2.505 -2.504a3.536 3.536 0 0 0 -5 -5l-.5 .5"></path>
      <path d="M9.548 9.544a3.5 3.5 0 0 0 -.548 .456l-4 4a3.536 3.536 0 0 0 5 5l.5 -.5"></path>
      <path d="M3 3l18 18"></path>
      <path d="M3 3l18 18"></path>
    </svg>
  )
}

function Excel(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={16}
      height={16}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#a)">
        <path
          d="M14.173 8.545H11.63V7.273h2.544v1.272Zm0 .727H11.63v1.273h2.544V9.272Zm0-5.998H11.63v1.273h2.544V3.274Zm0 2H11.63v1.272h2.544V5.274Zm0 5.998H11.63v1.272h2.544V11.27Zm1.758 2.508c-.073.378-.527.387-.83.4H9.447v1.636H8.319L0 14.36V1.641L8.368.183h1.08v1.45h5.458c.307.012.645-.01.912.174.187.269.17.61.182.92l-.007 9.461c-.01.53.049 1.07-.062 1.59Zm-9.266-2.852C6.163 9.91 5.653 8.9 5.153 7.882c.494-.99.981-1.985 1.467-2.98-.413.02-.826.046-1.236.075-.308.747-.666 1.474-.906 2.247-.223-.729-.52-1.43-.79-2.141l-1.2.069c.422.93.87 1.848 1.28 2.784-.482.91-.933 1.83-1.4 2.745.398.016.796.033 1.194.038.284-.723.637-1.42.884-2.157.222.792.598 1.524.907 2.282.438.031.874.059 1.312.084Zm8.468-8.432H9.448v.778h1.454v1.273H9.448v.727h1.454v1.272H9.448v.727h1.454v1.272H9.448v.727h1.454v1.273H9.448v.727h1.454v1.272H9.448v.84h5.685V2.496Z"
          fill={props.fill ?? "#1D1D1E"}
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h16v16H0z"/>
        </clipPath>
      </defs>
    </svg>
  )
}

function CSV(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={16}
      height={16}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.067 1.6a1.6 1.6 0 0 1 1.6-1.6h8.754l3.512 3.513V14.4a1.6 1.6 0 0 1-1.6 1.6H2.667a1.6 1.6 0 0 1-1.6-1.6V1.6Zm1.066 4.8h3.2v1.067H3.2v3.2h2.133v1.066h-3.2V6.4Zm7.467 0H6.4v3.2h2.133v1.067H6.4v1.066h3.2v-3.2H7.467V7.467H9.6V6.4Zm2.133 0h-1.066v3.954l1.6 1.6 1.6-1.6V6.4H12.8v3.513l-.533.533-.534-.533V6.4Z"
        fill={props.fill ?? "#1D1D1E"}
      />
    </svg>
  )
}

function CalendarGreen(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        d="m20.12,2.4h-3.01V.84c0-.46-.38-.84-.84-.84h0c-.46,0-.84.38-.84.84v1.56H6.24V.84c0-.46-.38-.84-.84-.84h0c-.46,0-.84.38-.84.84v1.56H1.56c-.86,0-1.56.7-1.56,1.56v17.7c0,.86.7,1.56,1.56,1.56h18.57c.86,0,1.56-.7,1.56-1.56V3.96c0-.86-.7-1.56-1.56-1.56Zm-4.69,1.3v.95c0,.46.38.84.84.84h0c.46,0,.84-.38.84-.84v-.95c.29.24.47.6.47,1.01,0,.72-.59,1.31-1.31,1.31s-1.31-.59-1.31-1.31c0-.4.18-.77.47-1.01Zm-10.87,0v.95c0,.46.38.84.84.84h0c.46,0,.84-.38.84-.84v-.95c.29.24.47.6.47,1.01,0,.72-.59,1.31-1.31,1.31s-1.31-.59-1.31-1.31c0-.4.18-.77.47-1.01Zm15.82,17.65c0,.32-.26.58-.58.58H1.87c-.32,0-.58-.26-.58-.58v-12.74h19.09v12.74Z"
        style={{
          fill: "#3bb877",
          stroke: "#3bb877",
          strokeWidth: 0,
          strokeMiterlimit: 0,
        }}
      />
      <path
        d="m10.84,10.76c-2.48,0-4.5,2.02-4.5,4.5s2.02,4.5,4.5,4.5,4.5-2.02,4.5-4.5-2.02-4.5-4.5-4.5Zm2.52,3.32l-2.88,2.86c-.17.17-.44.18-.62.01l-1.52-1.39c-.18-.17-.19-.45-.03-.63.17-.18.45-.19.63-.02l1.21,1.11,2.57-2.57c.18-.18.46-.18.64,0,.18.18.18.46,0,.64Z"
        style={{
          fill: "#3bb877",
        }}
      />
    </svg>
  );
}

function CalendarGray(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        d="m20.12,2.4h-3.01V.84c0-.46-.38-.84-.84-.84h0c-.46,0-.84.38-.84.84v1.56H6.24V.84c0-.46-.38-.84-.84-.84h0c-.46,0-.84.38-.84.84v1.56H1.56c-.86,0-1.56.7-1.56,1.56v17.7c0,.86.7,1.56,1.56,1.56h18.57c.86,0,1.56-.7,1.56-1.56V3.96c0-.86-.7-1.56-1.56-1.56Zm-4.69,1.3v.95c0,.46.38.84.84.84h0c.46,0,.84-.38.84-.84v-.95c.29.24.47.6.47,1.01,0,.72-.59,1.31-1.31,1.31s-1.31-.59-1.31-1.31c0-.4.18-.77.47-1.01Zm-10.87,0v.95c0,.46.38.84.84.84h0c.46,0,.84-.38.84-.84v-.95c.29.24.47.6.47,1.01,0,.72-.59,1.31-1.31,1.31s-1.31-.59-1.31-1.31c0-.4.18-.77.47-1.01Zm15.82,17.65c0,.32-.26.58-.58.58H1.87c-.32,0-.58-.26-.58-.58v-12.74h19.09v12.74Z"
        style={{
          fill: "#616161",
          stroke: "#616161",
          strokeWidth: 0,
          strokeMiterlimit: 10,
        }}
      />
      <path
        d="m10.84,10.76c-2.48,0-4.5,2.02-4.5,4.5s2.02,4.5,4.5,4.5,4.5-2.02,4.5-4.5-2.02-4.5-4.5-4.5Zm2.52,3.32l-2.88,2.86c-.17.17-.44.18-.62.01l-1.52-1.39c-.18-.17-.19-.45-.03-.63.17-.18.45-.19.63-.02l1.21,1.11,2.57-2.57c.18-.18.46-.18.64,0,.18.18.18.46,0,.64Z"
        style={{
          fill: "#616161",
        }}
      />
    </svg>
  );
}

function CalendarBlue(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        d="m20.12,2.4h-3.01V.84c0-.46-.38-.84-.84-.84h0c-.46,0-.84.38-.84.84v1.56H6.24V.84c0-.46-.38-.84-.84-.84h0c-.46,0-.84.38-.84.84v1.56H1.56c-.86,0-1.56.7-1.56,1.56v17.7c0,.86.7,1.56,1.56,1.56h18.57c.86,0,1.56-.7,1.56-1.56V3.96c0-.86-.7-1.56-1.56-1.56Zm-4.69,1.3v.95c0,.46.38.84.84.84h0c.46,0,.84-.38.84-.84v-.95c.29.24.47.6.47,1.01,0,.72-.59,1.31-1.31,1.31s-1.31-.59-1.31-1.31c0-.4.18-.77.47-1.01Zm-10.87,0v.95c0,.46.38.84.84.84h0c.46,0,.84-.38.84-.84v-.95c.29.24.47.6.47,1.01,0,.72-.59,1.31-1.31,1.31s-1.31-.59-1.31-1.31c0-.4.18-.77.47-1.01Zm15.82,17.65c0,.32-.26.58-.58.58H1.87c-.32,0-.58-.26-.58-.58v-12.74h19.09v12.74Z"
        style={{
          fill: "#05aaff",
          stroke: "#05aaff",
          strokeWidth: 0,
          strokeMiterlimit: 10,
        }}
      />
      <path
        d="m10.84,10.76c-2.48,0-4.5,2.02-4.5,4.5s2.02,4.5,4.5,4.5,4.5-2.02,4.5-4.5-2.02-4.5-4.5-4.5Zm2.52,3.32l-2.88,2.86c-.17.17-.44.18-.62.01l-1.52-1.39c-.18-.17-.19-.45-.03-.63.17-.18.45-.19.63-.02l1.21,1.11,2.57-2.57c.18-.18.46-.18.64,0,.18.18.18.46,0,.64Z"
        style={{
          fill: "#05aaff",
        }}
      />
    </svg>
  );
}

function CalendarExclamation(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path d="m20.12,2.4h-3.01V.84c0-.46-.38-.84-.84-.84h0c-.46,0-.84.38-.84.84v1.56H6.24V.84c0-.46-.38-.84-.84-.84h0c-.46,0-.84.38-.84.84v1.56H1.56c-.86,0-1.56.7-1.56,1.56v17.7c0,.86.7,1.56,1.56,1.56h18.57c.86,0,1.56-.7,1.56-1.56V3.96c0-.86-.7-1.56-1.56-1.56Zm-4.69,1.3v.95c0,.46.38.84.84.84h0c.46,0,.84-.38.84-.84v-.95c.29.24.47.6.47,1.01,0,.72-.59,1.31-1.31,1.31s-1.31-.59-1.31-1.31c0-.4.18-.77.47-1.01Zm-10.87,0v.95c0,.46.38.84.84.84h0c.46,0,.84-.38.84-.84v-.95c.29.24.47.6.47,1.01,0,.72-.59,1.31-1.31,1.31s-1.31-.59-1.31-1.31c0-.4.18-.77.47-1.01Zm15.82,17.65c0,.32-.26.58-.58.58H1.87c-.32,0-.58-.26-.58-.58v-12.74h19.09v12.74Z"
            style={{
            fill: "#ff5230",
            stroke: "#ff5230",
            strokeWidth: 0,
            strokeMiterlimit: 10,
          }}
      />
      <path
        d="m10.58,19.92c-.21,0-.4-.08-.55-.23-.16-.15-.23-.34-.23-.56s.08-.39.23-.55c.16-.15.34-.23.55-.23s.4.08.55.23c.16.15.23.33.23.55s-.08.41-.23.56c-.16.15-.34.23-.55.23Zm0-9.3c.34,0,.61.28.6.62l-.19,5.42c0,.22-.19.4-.41.4s-.41-.18-.41-.4l-.19-5.42c-.01-.34.26-.62.6-.62Z"
        style={{
          fill: "#ff5230",
        }}
      />
    </svg>
  );
}

function CalendarBell(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      x={0}
      y={0}
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        d="m20.12,2.4h-3.01V.84c0-.46-.38-.84-.84-.84h0c-.46,0-.84.38-.84.84v1.56H6.24V.84c0-.46-.38-.84-.84-.84h0c-.46,0-.84.38-.84.84v1.56H1.56c-.86,0-1.56.7-1.56,1.56v17.7c0,.86.7,1.56,1.56,1.56h18.57c.86,0,1.56-.7,1.56-1.56V3.96c0-.86-.7-1.56-1.56-1.56Zm-4.69,1.3v.95c0,.46.38.84.84.84h0c.46,0,.84-.38.84-.84v-.95c.29.24.47.6.47,1.01,0,.72-.59,1.31-1.31,1.31s-1.31-.59-1.31-1.31c0-.4.18-.77.47-1.01Zm-10.87,0v.95c0,.46.38.84.84.84h0c.46,0,.84-.38.84-.84v-.95c.29.24.47.6.47,1.01,0,.72-.59,1.31-1.31,1.31s-1.31-.59-1.31-1.31c0-.4.18-.77.47-1.01Zm15.82,17.65c0,.32-.26.58-.58.58H1.87c-.32,0-.58-.26-.58-.58v-12.74h19.09v12.74Zm-5.59-3.33c-.89-.89-1.39-2.09-1.39-3.35v-1.2c0-1.49-1.21-2.7-2.7-2.7s-2.7,1.21-2.7,2.7v1.2c0,1.26-.5,2.46-1.39,3.35-.07.07-.07.18,0,.25.03.03.08.05.13.05h7.92c.1,0,.18-.08.18-.18,0-.05-.02-.09-.05-.13Zm-4.09,1.75c.69,0,1.3-.43,1.53-1.08h-3.05c.23.65.84,1.08,1.53,1.08Z"
        style={{
          fill: "#ff9800",
          stroke: "#ff9800",
          strokeWidth: 0,
          strokeMiterlimit: 10,
        }}
      />
    </svg>
  );
}

function CalendarQuestion(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        d="m20.12,2.4h-3.01V.84c0-.46-.38-.84-.84-.84h0c-.46,0-.84.38-.84.84v1.56H6.24V.84c0-.46-.38-.84-.84-.84h0c-.46,0-.84.38-.84.84v1.56H1.56c-.86,0-1.56.7-1.56,1.56v17.7c0,.86.7,1.56,1.56,1.56h18.57c.86,0,1.56-.7,1.56-1.56V3.96c0-.86-.7-1.56-1.56-1.56Zm-4.69,1.3v.95c0,.46.38.84.84.84h0c.46,0,.84-.38.84-.84v-.95c.29.24.47.6.47,1.01,0,.72-.59,1.31-1.31,1.31s-1.31-.59-1.31-1.31c0-.4.18-.77.47-1.01Zm-10.87,0v.95c0,.46.38.84.84.84h0c.46,0,.84-.38.84-.84v-.95c.29.24.47.6.47,1.01,0,.72-.59,1.31-1.31,1.31s-1.31-.59-1.31-1.31c0-.4.18-.77.47-1.01Zm15.82,17.65c0,.32-.26.58-.58.58H1.87c-.32,0-.58-.26-.58-.58v-12.74h19.09v12.74Z"
        style={{
          fill: "#313642",
          stroke: "#313642",
          strokeWidth: 0,
          strokeMiterlimit: 10,
        }}
      />
      <path
        d="m10.86,17.56c-.18,0-.32-.14-.32-.32,0-.42.06-.79.18-1.1.09-.23.23-.46.43-.7.14-.17.4-.42.77-.75.37-.33.62-.59.73-.79s.17-.41.17-.64c0-.42-.16-.79-.49-1.1s-.73-.48-1.2-.48-.84.14-1.15.43c-.22.21-.39.51-.5.89-.08.26-.33.43-.6.4-.34-.04-.57-.38-.47-.71.15-.51.4-.92.76-1.24.49-.44,1.14-.65,1.95-.65.86,0,1.54.23,2.05.7s.77,1.03.77,1.69c0,.38-.09.74-.27,1.06-.18.32-.53.72-1.05,1.18-.35.31-.58.54-.69.69s-.19.32-.24.51c-.04.14-.06.35-.08.62,0,.17-.15.31-.33.31h-.4Zm-.38,1.55c0-.34.27-.61.61-.61s.61.27.61.61-.27.61-.61.61-.61-.27-.61-.61h0Z"
        style={{
          fill: "#313642",
        }}
      />
    </svg>
  );
}

function CalendarCancelled(props: SVGProps<SVGSVGElement>) {
  return (
      <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlSpace="preserve"
          x={0}
          y={0}
          viewBox="0 0 24 24"
          width="1em"
          height="1em"
          {...props}
      >
        <path
            d="m20.12,2.4h-3.01V.84c0-.46-.38-.84-.84-.84h0c-.46,0-.84.38-.84.84v1.56H6.24V.84c0-.46-.38-.84-.84-.84h0c-.46,0-.84.38-.84.84v1.56H1.56c-.86,0-1.56.7-1.56,1.56v17.7c0,.86.7,1.56,1.56,1.56h18.57c.86,0,1.56-.7,1.56-1.56V3.96c0-.86-.7-1.56-1.56-1.56Zm-4.69,1.3v.95c0,.46.38.84.84.84h0c.46,0,.84-.38.84-.84v-.95c.29.24.47.6.47,1.01,0,.72-.59,1.31-1.31,1.31s-1.31-.59-1.31-1.31c0-.4.18-.77.47-1.01Zm-10.87,0v.95c0,.46.38.84.84.84h0c.46,0,.84-.38.84-.84v-.95c.29.24.47.6.47,1.01,0,.72-.59,1.31-1.31,1.31s-1.31-.59-1.31-1.31c0-.4.18-.77.47-1.01Zm15.82,17.65c0,.32-.26.58-.58.58H1.87c-.32,0-.58-.26-.58-.58v-12.74h19.09v12.74Z"
            style={{
              fill: "#202020",
              stroke: "#202020",
              strokeWidth: 0,
              strokeMiterlimit: 10,
            }}
        />

        <path
            d="m11.66,15.26l3.48-3.48c.23-.23.23-.59,0-.82-.23-.23-.59-.23-.82,0l-3.48,3.48-3.48-3.48c-.23-.23-.59-.23-.82,0-.23.23-.23.59,0,.82l3.48,3.48-3.48,3.48c-.23.23-.23.59,0,.82.11.11.26.17.41.17s.3-.06.41-.17l3.48-3.48,3.48,3.48c.11.11.26.17.41.17s.3-.06.41-.17c.23-.23.23-.59,0-.82l-3.48-3.48Z"
            style={{
              fill: "#313642",
            }}
        />
      </svg>
  );
}

function Warning(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M12 15H12.01M12 12V9M4.98207 19H19.0179C20.5615 19 21.5233 17.3256 20.7455 15.9923L13.7276 3.96153C12.9558 2.63852 11.0442 2.63852 10.2724 3.96153L3.25452 15.9923C2.47675 17.3256 3.43849 19 4.98207 19Z"
        stroke={props.stroke ?? "#1D1D1E"}
        strokeWidth={props.strokeWidth ?? "1"}
        strokeLinecap="round"
        strokeLinejoin="round"/>
    </svg>
  )
}

const Zip = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 56 56"
      {...props}
    >
      <g>
        <path
          style={{fill:"#e9e9e0"}}
          d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
        />
        <polygon
          style={{fill:"#d9d7ca"}}
          points="37.5,0.151 37.5,12 49.349,12"
        />
        <path
          style={{fill:"#556080"}}
          d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
        />
        <g>
          <path
            style={{fill:"#fff"}}
            d="M25.266,42.924v1.326l-4.799,7.205l-0.273,0.219h5.072V53h-6.699v-1.326l4.799-7.205l0.287-0.219 h-5.086v-1.326H25.266z"
          />
          <path
            style={{fill:"#fff"}}
            d="M29.271,53h-1.668V42.924h1.668V53z"
          />
          <path
            style={{fill:"#fff"}}
            d="M33.414,53h-1.641V42.924h2.898c0.428,0,0.852,0.068,1.271,0.205 c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306 c0,0.511-0.087,0.973-0.26,1.388c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656 s-0.921,0.232-1.449,0.232h-1.217V53z M33.414,44.168v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103 c0.196-0.068,0.376-0.18,0.54-0.335s0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032c0-0.164-0.023-0.354-0.068-0.567 c-0.046-0.214-0.139-0.419-0.28-0.615c-0.142-0.196-0.34-0.36-0.595-0.492c-0.255-0.132-0.593-0.198-1.012-0.198H33.414z">
          </path>
        </g>
        <g>
          <path
            style={{fill:"#c8bdb8"}}
            d="M28.5,24v-2h2v-2h-2v-2h2v-2h-2v-2h2v-2h-2v-2h2V8h-2V6h-2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2 h-4v5c0,2.757,2.243,5,5,5s5-2.243,5-5v-5H28.5z M30.5,29c0,1.654-1.346,3-3,3s-3-1.346-3-3v-3h6V29z"
          />
          <path
            style={{fill:"#c8bdb8"}}
            d="M26.5,30h2c0.552,0,1-0.447,1-1s-0.448-1-1-1h-2c-0.552,0-1,0.447-1,1S25.948,30,26.5,30z"
          />
        </g>
      </g>
    </svg>
  )
}

const Document = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 56 56"
      {...props}
    >
      <g>
        <path style={{fill: "#e9e9e0"}} d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"></path>
        <polygon style={{fill: "#d9d7ca"}} points="37.5,0.151 37.5,12 49.349,12"></polygon>
        <path style={{fill: "#8697cb"}} d="M18.5,13h-6c-0.552,0-1-0.448-1-1s0.448-1,1-1h6c0.552,0,1,0.448,1,1S19.052,13,18.5,13z"></path>
        <path style={{fill: "#8697cb"}} d="M21.5,18h-9c-0.552,0-1-0.448-1-1s0.448-1,1-1h9c0.552,0,1,0.448,1,1S22.052,18,21.5,18z"></path>
        <path style={{fill: "#8697cb"}} d="M25.5,18c-0.26,0-0.52-0.11-0.71-0.29c-0.18-0.19-0.29-0.45-0.29-0.71c0-0.26,0.11-0.52,0.29-0.71 c0.37-0.37,1.05-0.37,1.42,0c0.18,0.19,0.29,0.45,0.29,0.71c0,0.26-0.11,0.52-0.29,0.71C26.02,17.89,25.76,18,25.5,18z"></path>
        <path style={{fill: "#8697cb"}} d="M37.5,18h-8c-0.552,0-1-0.448-1-1s0.448-1,1-1h8c0.552,0,1,0.448,1,1S38.052,18,37.5,18z"></path>
        <path style={{fill: "#8697cb"}} d="M12.5,33c-0.26,0-0.52-0.11-0.71-0.29c-0.18-0.19-0.29-0.45-0.29-0.71c0-0.26,0.11-0.52,0.29-0.71 c0.37-0.37,1.05-0.37,1.42,0c0.18,0.19,0.29,0.44,0.29,0.71c0,0.26-0.11,0.52-0.29,0.71C13.02,32.89,12.76,33,12.5,33z"></path>
        <path style={{fill: "#8697cb"}} d="M24.5,33h-8c-0.552,0-1-0.448-1-1s0.448-1,1-1h8c0.552,0,1,0.448,1,1S25.052,33,24.5,33z"></path>
        <path style={{fill: "#8697cb"}} d="M43.5,18h-2c-0.552,0-1-0.448-1-1s0.448-1,1-1h2c0.552,0,1,0.448,1,1S44.052,18,43.5,18z"></path>
        <path style={{fill: "#8697cb"}} d="M34.5,23h-22c-0.552,0-1-0.448-1-1s0.448-1,1-1h22c0.552,0,1,0.448,1,1S35.052,23,34.5,23z"></path>
        <path style={{fill: "#8697cb"}} d="M43.5,23h-6c-0.552,0-1-0.448-1-1s0.448-1,1-1h6c0.552,0,1,0.448,1,1S44.052,23,43.5,23z"></path>
        <path style={{fill: "#8697cb"}} d="M16.5,28h-4c-0.552,0-1-0.448-1-1s0.448-1,1-1h4c0.552,0,1,0.448,1,1S17.052,28,16.5,28z"></path>
        <path style={{fill: "#8697cb"}} d="M30.5,28h-10c-0.552,0-1-0.448-1-1s0.448-1,1-1h10c0.552,0,1,0.448,1,1S31.052,28,30.5,28z"></path>
        <path style={{fill: "#8697cb"}} d="M43.5,28h-9c-0.552,0-1-0.448-1-1s0.448-1,1-1h9c0.552,0,1,0.448,1,1S44.052,28,43.5,28z"></path>
        <path style={{fill: "#0096e6"}} d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"></path>
        <g>
          <path style={{fill: "#fff"}} d="M23.5,47.682c0,0.829-0.089,1.538-0.267,2.126s-0.403,1.08-0.677,1.477s-0.581,0.709-0.923,0.937 s-0.672,0.398-0.991,0.513c-0.319,0.114-0.611,0.187-0.875,0.219C19.503,52.984,19.307,53,19.18,53h-3.814V42.924H18.4 c0.848,0,1.593,0.135,2.235,0.403s1.176,0.627,1.6,1.073s0.74,0.955,0.95,1.524C23.395,46.494,23.5,47.08,23.5,47.682z M18.633,51.797c1.112,0,1.914-0.355,2.406-1.066s0.738-1.741,0.738-3.09c0-0.419-0.05-0.834-0.15-1.244 c-0.101-0.41-0.294-0.781-0.581-1.114s-0.677-0.602-1.169-0.807s-1.13-0.308-1.914-0.308h-0.957v7.629H18.633z"></path>
          <path style={{fill: "#fff"}} d="M33.475,47.914c0,0.848-0.107,1.595-0.321,2.242c-0.214,0.647-0.511,1.185-0.889,1.613 c-0.378,0.429-0.82,0.752-1.326,0.971s-1.06,0.328-1.661,0.328s-1.155-0.109-1.661-0.328s-0.948-0.542-1.326-0.971 c-0.378-0.429-0.675-0.966-0.889-1.613c-0.214-0.647-0.321-1.395-0.321-2.242s0.107-1.593,0.321-2.235 c0.214-0.643,0.51-1.178,0.889-1.606c0.378-0.429,0.82-0.754,1.326-0.978s1.06-0.335,1.661-0.335s1.155,0.111,1.661,0.335 s0.948,0.549,1.326,0.978c0.378,0.429,0.674,0.964,0.889,1.606C33.367,46.321,33.475,47.066,33.475,47.914z M29.236,51.729 c0.337,0,0.658-0.066,0.964-0.198c0.305-0.132,0.579-0.349,0.82-0.649c0.241-0.301,0.431-0.695,0.567-1.183 s0.209-1.082,0.219-1.784c-0.009-0.684-0.08-1.265-0.212-1.743c-0.132-0.479-0.314-0.873-0.547-1.183s-0.497-0.533-0.793-0.67 c-0.296-0.137-0.608-0.205-0.937-0.205c-0.337,0-0.659,0.063-0.964,0.191c-0.306,0.128-0.579,0.344-0.82,0.649 c-0.242,0.306-0.431,0.699-0.567,1.183s-0.21,1.075-0.219,1.777c0.009,0.684,0.08,1.267,0.212,1.75 c0.132,0.483,0.314,0.877,0.547,1.183s0.497,0.528,0.793,0.67C28.596,51.658,28.908,51.729,29.236,51.729z"></path>
          <path style={{fill: "#fff"}} d="M42.607,51.975c-0.374,0.364-0.798,0.638-1.271,0.82c-0.474,0.183-0.984,0.273-1.531,0.273 c-0.602,0-1.155-0.109-1.661-0.328s-0.948-0.542-1.326-0.971c-0.378-0.429-0.675-0.966-0.889-1.613 c-0.214-0.647-0.321-1.395-0.321-2.242s0.107-1.593,0.321-2.235c0.214-0.643,0.51-1.178,0.889-1.606 c0.378-0.429,0.822-0.754,1.333-0.978c0.51-0.224,1.062-0.335,1.654-0.335c0.547,0,1.057,0.091,1.531,0.273 c0.474,0.183,0.897,0.456,1.271,0.82l-1.135,1.012c-0.228-0.265-0.481-0.456-0.759-0.574c-0.278-0.118-0.567-0.178-0.868-0.178 c-0.337,0-0.659,0.063-0.964,0.191c-0.306,0.128-0.579,0.344-0.82,0.649c-0.242,0.306-0.431,0.699-0.567,1.183 s-0.21,1.075-0.219,1.777c0.009,0.684,0.08,1.267,0.212,1.75c0.132,0.483,0.314,0.877,0.547,1.183s0.497,0.528,0.793,0.67 c0.296,0.142,0.608,0.212,0.937,0.212s0.636-0.06,0.923-0.178s0.549-0.31,0.786-0.574L42.607,51.975z"></path>
        </g>
      </g>
    </svg>
  );
}

const ColorBucket = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Color">
        <path style={{fill: props.color ?? '#1F2326'}} d="M5.42462 1.18986C5.18054 0.945786 4.78481 0.945786 4.54073 1.18986C4.29666 1.43394 4.29666 1.82967 4.54073 2.07375L6.2998 3.83282L2.46619 7.66643C1.83158 8.30104 1.83158 9.32993 2.46619 9.96453L6.0589 13.5572C6.6935 14.1918 7.72239 14.1918 8.35699 13.5572L12.6326 9.28168C12.8766 9.0376 12.8766 8.64188 12.6326 8.3978L5.42462 1.18986ZM3.35007 8.55032L7.18369 4.7167L11.3067 8.83974L7.47311 12.6734C7.32666 12.8198 7.08923 12.8198 6.94278 12.6734L3.35007 9.08065C3.20362 8.9342 3.20362 8.69676 3.35007 8.55032ZM13.2265 15.0153C12.7239 15.0153 12.2993 14.8455 11.953 14.5059C11.6066 14.1663 11.4334 13.7452 11.4334 13.2426C11.4334 12.9166 11.5081 12.6007 11.6575 12.2951C11.8069 11.9894 11.9835 11.7008 12.1873 11.4291L12.7986 10.6752C12.9072 10.5257 13.0499 10.451 13.2265 10.451C13.4031 10.451 13.5457 10.5257 13.6544 10.6752L14.2453 11.4291C14.4355 11.7008 14.6087 11.9894 14.7649 12.2951C14.9211 12.6007 14.9992 12.9166 14.9992 13.2426C14.9992 13.7452 14.826 14.1663 14.4796 14.5059C14.1332 14.8455 13.7155 15.0153 13.2265 15.0153Z">
        </path>
      </g>
    </svg>
  )
}

const ClearApproved = (props: SVGProps<SVGSVGElement>) => {
  return (
      <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" {...props}>
        <path fill="black" d="m.29 12.71l1.42-1.42l2.22 2.22l8.3-10.14l1.54 1.26l-9.7 11.86zM12 10h5v2h-5zm-3 4h5v2H9zm6-8h5v2h-5z" strokeLinecap="round"
              strokeLinejoin="round"></path></svg>);
}


const OpenInNewTab = (props: SVGProps<SVGSVGElement>) => {
  return (
      <svg
          xmlns="http://www.w3.org/2000/svg"
          width={22}
          height={22}
          viewBox="0 0 2048 2048"
          {...props}
      >
        <path fill="black" d="M2048 0v1664h-384v384H0V384h384V0zm-128 1536V128H512v256h256v128H128v1408h1408v-640h128v256zm-979-339l-90-90l594-595h-421V384h640v640h-128V603z"></path>
      </svg>
  );
}

const SystemIcons = {
  Warning,
  CSV,
  Excel,
  Unlink,
  TextFormat,
  Paragraph,
  Numeric,
  Drag,
  Projects,
  Assets,
  Requirement,
  FilesOutlined,
  FilesFilled,
  Milestone,
  Image,
  Tasks,
  Form,
  Templates,
  ArrowLeft,
  ArrowRight,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  ChevronUp,
  Check,
  Close,
  Edit,
  DownloadTimeData,
  Import,
  Export,
  Settings,
  Minus,
  Plus,
  PlusCircle,
  Eye,
  EyeOff,
  NotificationsFilled,
  Notifications,
  FavoriteFilled,
  FavoriteOutlined,
  DeleteOutlined,
  Mute,
  ChatOutlined,
  Send,
  Info,
  Video,
  Phone,
  Attach,
  Teams,
  AddUser,
  RemoveUser,
  User,
  Filter,
  Search,
  Calendar,
  Collapse,
  Expand,
  MoreHorizontal,
  MoreVertical,
  Menu,
  Location,
  Pin,
  PinFilled,
  Unpin,
  ChatFilled,
  Play,
  Pause,
  Stop,
  LockFilled,
  LockOutlined,
  Arrow_Right,
  Tips,
  Camera,
  SwitchCamera,
  Share,
  Retake,
  Retry,
  Move,
  Offline,
  ReadMessage,
  NameOnly,
  NameOnlyFilled,
  Navigation,
  NavigationFilled,
  Login,
  Logout,
  Volume1,
  Volume2,
  Language,
  Database,
  Mail,
  AlertCircle,
  CloseCircle,
  CheckCircle,
  Upload,
  Download,
  Unselected,
  Selected,
  Zap,
  ZapOff,
  CloudUpload,
  CorruptedFileFilled,
  CorruptedFileOutline,
  LoaderOnWhite,
  Zip,
  Document,
  ColorBucket,
  ClearApproved,
  OpenInNewTab
};

const Icons = {
  SystemIcons
}

export {SystemIcons};
export const CalendarIcons = {
  CalendarGreen,
  CalendarBlue,
  CalendarExclamation,
  CalendarBell,
  CalendarGray,
  CalendarQuestion,
  CalendarCancelled,
}
export default Icons;
